module.exports = __webpack_public_path__ + "f5a011786d3206643c82a909b1770b78.png";